/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_Too_LongInputs */

const en_password_reset_code_too_long = /** @type {(inputs: Password_Reset_Code_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code too long`)
};

const es_password_reset_code_too_long = /** @type {(inputs: Password_Reset_Code_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código demasiado largo`)
};

/**
* | output |
* | --- |
* | "Code too long" |
*
* @param {Password_Reset_Code_Too_LongInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_too_long = /** @type {((inputs?: Password_Reset_Code_Too_LongInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_Too_LongInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_too_long(inputs)
	return en_password_reset_code_too_long(inputs)
});